MassiaDapValidator.$inject = ['validator'];

export default function MassiaDapValidator(validator) {
	const instance = new validator();
	instance.ruleFor('numero').notEmpty().when(isNotCodeAuto).withMessage('VALIDATION_NOTEMPTY');
	//instance.ruleFor('siteProducteur').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('dateDebut').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('dateFin').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('transporteurs').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('chantier').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('demandeur').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('dechets').notEmpty().withMessage('VALIDATION_NOTEMPTY');

	return instance;

	function isNotCodeAuto(obj) {
		return !obj.estCodeAuto;
	}
}
